import * as jwt_decode from 'jwt-decode';
import store from '../store'

let getPermissions = function (token) {
    let tokenDecoded = jwt_decode(token);
    if (tokenDecoded["Permissions"]) {
        let permissions = {};
        let decoded = tokenDecoded["Permissions"].split(',');
        for (var p in decoded) {
            permissions[decoded[p]] = true
        }
        let loggedInUserId = tokenDecoded["loggedInUserId"];
        let loggedInUserEmail = tokenDecoded["loggedInUser"];
        let avatarUrl = tokenDecoded["avatarUrl"];

        localPermissions.set(JSON.stringify(permissions));
        localStorage.setItem('loggedInUserId', loggedInUserId || '');
        localStorage.setItem('loggedInUserEmail', loggedInUserEmail || '');
        localStorage.setItem('avatarUrl', avatarUrl || '');

        store.commit('setPermissions', permissions);
        store.commit('setLoggedInUserId', loggedInUserId);
        store.commit('setLoggedInUserEmail', loggedInUserEmail);
        store.commit('setAvatarUrl', avatarUrl);
    }   
}

const localPermissions = {
    get: () => {
        return localStorage.getItem('permissions') || '';
    },
    set: (permissions) => {
        localStorage.setItem('permissions', permissions || '');
    }
};

export default {
    getPermissions,
    localPermissions
}
